<template><div><h1 id="verdankungen-statistik" tabindex="-1"><a class="header-anchor" href="#verdankungen-statistik"><span>Verdankungen-Statistik</span></a></h1>
<p>Verdankungen-Statistik — Listet die Zeitdauer von Responses bis zur Verdankung aus</p>
<h2 id="beschreibung" tabindex="-1"><a class="header-anchor" href="#beschreibung"><span>Beschreibung</span></a></h2>
<p>Diese Statistik listet die Anzahl Verdankungen anhand der Zeitdauer vom Response bis zum Verdankungslauf aus. Darin sind auch Verdankungen aus Anlasspenden enthalten.</p>
<p>Pfad: <code v-pre>Personen → Auswertungen → Verdankungen-Statistik (Unicef Indikatoren)</code></p>
<h2 id="parameter" tabindex="-1"><a class="header-anchor" href="#parameter"><span>Parameter</span></a></h2>
<p><strong>Parameter</strong></p>
<dl>
<dt>von/bis Datum</dt>
<dd>Datumsbereich für die Auswertung.</dd>
<dt>Wartezeit von/bis</dt>
<dd>Anzahl Tage bis zur Verdankung.</dd>
</dl>
<h2 id="output-liste" tabindex="-1"><a class="header-anchor" href="#output-liste"><span>Output (Liste)</span></a></h2>
<p>Die Ausgabe beinhaltet die folgenden Spalten:</p>
<table>
<thead>
<tr>
<th>Spalte</th>
<th>Bedeutung</th>
</tr>
</thead>
<tbody>
<tr>
<td>Wartezeit von / bis</td>
<td>Anzahl Tage (Response bis Verdankung)</td>
</tr>
<tr>
<td>Anzahl Verdankungen</td>
<td>Anzahl Verdankungen pro Zeitspanne</td>
</tr>
<tr>
<td>%</td>
<td>Verdankungen pro Zeitspanne in %</td>
</tr>
<tr>
<td>Anzahl Anlassverdankungen</td>
<td>Anzahl Verdankungen aus Anlassspenden pro Zeitspanne</td>
</tr>
<tr>
<td>%</td>
<td>Anlassverdankungen pro Zeitspanne in %</td>
</tr>
<tr>
<td>Total Verdankungen</td>
<td>Anzahl Verdankungen (inkl. aus Anlassspenden) pro Zeitspanne</td>
</tr>
<tr>
<td>%</td>
<td>Total Verdankungen pro Zeitspanne in %</td>
</tr>
</tbody>
</table>
<pre><code>                                                  Wartezeit Verdankungen
</code></pre>
<p>Wartezeit von         Wartezeit bis Anzahl Verdankungen      % Anzahl Anlassverdankungen      % Total Verdankungen      %</p>
<hr>
<pre><code>        0                    10                 930  68.74                         0   0.00                930  68.74
       11                    20                 274  20.25                         0   0.00                274  20.25
       21                    30                 100   7.39                         0   0.00                100   7.39
       31 unbegrenzt                             49   3.62                         0   0.00                 49   3.62
          noch nicht bearbeitet                   0   0.00                         0   0.00                  0   0.00
          zusammen                            1'353 100.00                         0 100.00              1'353 100.00
</code></pre>
</div></template>


